module.exports = __webpack_public_path__ + "static/media/marker-agent.ea2b0be4.svg";